// extracted by mini-css-extract-plugin
export default {"page":"TestQuestions_page__WCFye","questions":"TestQuestions_questions__+h-Mb","btnContainer":"TestQuestions_btnContainer__yjwfd","btn":"TestQuestions_btn__lbQyk"};